/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var Interval;

(function (Interval) {
  Interval["DAY"] = "day";
  Interval["WEEK"] = "week";
  Interval["MONTH"] = "month";
  Interval["YEAR"] = "year";
})(Interval || (Interval = {}));